import { Injectable, inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'

@Injectable({ providedIn: 'root' })
export class OldBoardGuard {
  private authService = inject(AuthService)
  private router = inject(Router)

  async canActivate(): Promise<boolean | UrlTree> {
    const customer = this.authService.customer() ?? (await this.authService.ensureCustomerLoaded())
    if (customer) {
      if (this.authService.isNewCustomer) {
        return this.router.parseUrl('/dashboard-visa/login')
      }
      return true
    }
    return this.router.parseUrl('/dashboard-visa/login')
  }
}
